import { useEffect, useState } from 'react'

import css from '../sass/adminitem.module.scss'
import themeCss from '../../components/sass/theme.module.scss'
import { canEditAuction } from '../permissionsutil'

import grayDelete from '../images/trash-icon-gray.svg'
import grayEdit from '../images/edit-icon-gray.svg'
import blueEdit from '../images/edit-icon-blue.svg'

import { getImageUrl } from '../../util/images'

import { formatMoney } from 'services/util'
import FixedItemDeleteButton from '../FixedItemDeleteButton'
import ItemPurchaseHistoryTable from '../UserDetail/ItemPurchaseHistoryTable'
import ItemLinkCopyButton from '../ItemLinkCopyButton'

export default function FixedItemDisplayRow({ item, auction, liveStatus, updateEditItemId, showEditItemModal, refreshAdminAuctionQuery, hasEnded, isUserSR }) {

  const [imageUrl, setImageUrl] = useState()

  // use effect for auction banner image
  useEffect(() => {
    const url = getImageUrl(auction?.AuctionCode, item?.ItemCode, item?.ImageFilename)
    setImageUrl(url)
  }, [auction, item])

  const generateQuantityText = (value) => {
    if (value === undefined || value === null || value === Number.POSITIVE_INFINITY) return 'Unlimited'
    if (value === 0) return 'Sold Out'
    else return value
  }

  if (isUserSR) {
    return (
      <>
        <tr className={css['admin-item-row']}>
          <td>
            <img src={imageUrl} alt={item?.Title}/>
          </td>
          <td>{item?.Title}</td>
          <td>{item?.Description}</td>
          <td>{item?.TotalItemsAvailable ? item.TotalItemsAvailable: 'Unlimited'}</td>
          <td>${formatMoney(item?.PurchasePrice)}</td>
          <td>${formatMoney(item?.Value)}</td>
        </tr>
      </>
    )
  }

  return (
    <>
      <tr className={css['admin-item-row']}>
        <td>
          {(hasEnded || !canEditAuction(auction) || isUserSR)
          ? <div className={css['admin-item-row-actions-ended']}>
              <img className={css['admin-item-action-icons']} src={grayDelete} alt={'Fixed Item Delete Icon - action not available'}/>
              <img className={css['admin-item-action-icons']} src={grayEdit} alt={'Fixed Item Edit Icon - action not available'}/>
              <ItemLinkCopyButton item={item} auction={auction} />
            </div>
          : <div className={css['admin-item-row-actions']}>
              <FixedItemDeleteButton item={item} refreshAdminAuctionQuery={refreshAdminAuctionQuery} style={'text'} />
              <button className={`${css['admin-item-edit-button']}`} onClick={()=>updateEditItemId(item.FixedItemId)}>
                <img className={css['admin-item-action-icons']} src={blueEdit} alt={'Fixed Item Edit Icon'}/>
              </button>
              <ItemLinkCopyButton item={item} auction={auction} />
            </div>}
        </td>

        <td>
          <img src={imageUrl} alt={item?.Title}/>
        </td>

        <td>{item?.Title}</td>
        <td>{item?.Category ? item.Category : 'N/A'}</td>
        <td>{item?.TotalItemsAvailable ? formatMoney(item.TotalItemsAvailable): 'Unlimited'}</td>
        <td>{item?.TotalItemsPurchased > 0 ? <ItemPurchaseHistoryTable item={item} users={item?.adminSummary?.Users} /> : '0'}</td>
        <td>{formatMoney(generateQuantityText(item?.TotalItemsRemaining))}</td>
        <td>${formatMoney(item?.PurchasePrice)}</td>
        <td>${formatMoney(item?.Value)}</td>
        <td>${formatMoney(item?.adminSummary?.Totals?.AmountRaised)}</td>
        <td>{formatMoney(item?.adminSummary?.Totals?.BuyerCount)}</td>
      </tr>
    </>
  )
}
